/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["portlet", "option"];

  selectOption(event) {
    const portlet = event.currentTarget;
    const inputIndex = this.portletTargets.indexOf(portlet);
    const input = this.optionTargets[inputIndex];

    this.portletTargets.forEach((item) => item.removeAttribute("open"));
    portlet.setAttribute("open", "");
    input.checked = true;
  }
}
